import React, { useState, useEffect } from "react";
import { FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ItemCategoryAutoComplete,
  ProductGroupAutoComplete,
} from "../AutoComplete/AutoCompletes";
import { Option } from "../../Types/CommonTypes";
type FieldKey = "category" | "group";

interface Props {
  itemCategoryCode?: string |null;
  productGroupCode?: string |null;
  onChange: (itemCategory: string, productGroup: string) => void;
    disabled?: boolean;

    wrapItem?: (node: React.ReactNode, key: FieldKey) => React.ReactNode;
}

const ItemCategoryProductGroupSelect: React.FC<Props> = ({
  itemCategoryCode,
  productGroupCode,
  onChange,
    disabled = false,
    wrapItem,
}) => {
  const { t } = useTranslation();

  const [category, setCategory] = useState(itemCategoryCode || "");
  const [group, setGroup] = useState(productGroupCode || "");
    const wrap = wrapItem ?? ((node: React.ReactNode) => node);

  useEffect(() => setCategory(itemCategoryCode || ""), [itemCategoryCode]);
  useEffect(() => setGroup(productGroupCode || ""), [productGroupCode]);

  const handleCategoryChange = (selected: Option | null) => {
      const code = selected?.value || "";

    setCategory(code);
    setGroup("");
    onChange(code, "");
  };

  const handleGroupChange = (selected: Option | null) => {
      const code = selected?.value || "";
  
    setGroup(code);
    onChange(category, code);
  };

    const categoryField = (
        <FormControl fullWidth margin="normal">
            <ItemCategoryAutoComplete
                valueId={category || null}
                onChange={handleCategoryChange}
                disabled={disabled}
                load={true}
            />
        </FormControl>
    );

    const groupField = (
        <FormControl fullWidth margin="normal">
            <ProductGroupAutoComplete
                itemCategoryCode={category || null}
                valueId={group || null}
                onChange={handleGroupChange}
                disabled={disabled}
                load={!!category}
            />
        </FormControl>
    );

    return (
        <>
            {wrap(categoryField, "category")}
            {wrap(groupField, "group")}
        </>
    );
};

export default ItemCategoryProductGroupSelect;
